
import backArrow from "../../../images/arrow-prev-light.png";
import whiteCalIcon from "../../../images/white-cal.png";

export default theme => ({
    blogBanner: {
        position: 'relative',
        '& .go-back': {
            backgroundColor: 'transparent',
            border: 'none',
            color: theme.palette.common.white,
            fontFamily: theme.headerFont,
            fontSize: 14,
            letterSpacing: '0.05em',
            lineHeight: '18px',
            textTransform: 'uppercase',
            padding: 0,
            outline: 'none !important',
            paddingLeft: 28,
            backgroundImage: 'url(' + backArrow + ')',
            backgroundPosition: 'center left',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain',
            transition: 'opacity .3s ease-in-out',
            position: 'absolute',
            top: 20,
            left: 0,
            zIndex: 5,
            '&:hover, &:focus': {
                opacity: 0.8,
            },
            [theme.breakpoints.up('md')]: {
                bottom: 40,
                top: 'auto',
                fontSize: 16,
                left: 'calc(50% + 40px)',
                transform: 'translateX(-50vw)',
            }
        },
        '& .desktop-bg': {
            display: 'none !important',
            [theme.breakpoints.up('md')]: {
                display: 'block !important',
            },
        },
        '& .mobile-bg': {
            display: 'block !important',
        },
        [theme.breakpoints.up('md')]: {
            '& .mobile-bg': {
                display: 'none !important',
            }
        },
        '& > .gatsby-image-wrapper': {
            height: '480px !important',
            marginLeft: '50%',
            transform: 'translateX(-50%)',
            maxWidth: '100vw',
            width: 'calc(100% + 50px) !important',
            zIndex: '1',
            [theme.breakpoints.up('md')]: {
                height: '540px !important',
                width: '100vw !important',
                '& > div': {
                    paddingBottom: '50% !important',
                }
            },
            '&::after': {
                position: 'absolute',
                display: 'block',
                content: '""',
                bottom: '0',
                left: '0',
                right: '0',
                height: 300,
                zIndex: '2',
                background: 'linear-gradient(to bottom, rgba(0,0,0,0) 0%,rgba(0,0,0,1) 45%,rgba(0,0,0,1) 100%)',
                opacity: '0.3',
                [theme.breakpoints.up('md')]: {
                    height: 340,
                    opacity: '0.51',
                    background: 'linear-gradient(to bottom, rgba(0,0,0,0) 0%,rgba(0,0,0,0.58) 33%,rgba(0,0,0,1) 66%,rgba(0,0,0,1) 100%)',
                },
            },
        },
        '& .banner-meta': {
            position: 'absolute',
            bottom: 42,
            zIndex: 1,
            [theme.breakpoints.up('md')]: {
                bottom: '50%',
                maxWidth: 550,
                transform: 'translateY(50%)',
            },
            '& h1, & h2, & h3, & h4, & h5, & h6' : {
                color: 'white',
                marginBottom: '0',
                fontSize: 24,
                lineHeight: 1.25,
                letterSpacing: '0.056em',
                textTransform: 'uppercase',
                [theme.breakpoints.up('md')]: {
                    margin: 0,
                    fontSize: 48,
                    letterSpacing: '0.048em',
                },
            },
        },
        '& .date': {
            display: 'block',
            color: theme.palette.secondary.contrastText,
            paddingBottom: 5,
            borderBottom: '1px solid ' + theme.palette.secondary.contrastText,
            fontSize: 12,
            fontFamily: theme.headerFont,
            letterSpacing: '0.04em',
            lineHeight: 1.25,
            fontWeight: 'bold',
            textTransform: 'uppercase',
            marginBottom: 24,
            [theme.breakpoints.up('md')]: {
                position: 'absolute',
                width: 'calc(100vw - 80px)',
                top: 40,
                left: '50%',
                transform: 'translateX(-50%)',
                display: 'flex',
                flexDirection: 'row',
                borderBottom: 'none',
                paddingBottom: 0,
                alignItems: 'center',
                zIndex: 1,
                fontSize: 16,
                '&::after': {
                    content: '""',
                    display: 'block',
                    height: 1,
                    backgroundColor: theme.palette.secondary.contrastText,
                    flex: '1 0 auto',
                    marginLeft: 36,
                }
            },
            '&.mobile': {
                [theme.breakpoints.up('md')]: {
                    display: 'none',
                }
            },
            '&.desktop': {
                display: 'none',
                [theme.breakpoints.up('md')]: {
                    display: 'flex',
                }
            },
            '&::before': {
                content: '""',
                width: 15,
                height: 15,
                display: 'inline-block',
                marginRight: 10,
                backgroundImage: 'url(' + whiteCalIcon + ')',
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                verticalAlign: 'bottom',
            }
        },
        '&.left-top .gatsby-image-wrapper img': {
            objectPosition: 'left top !important',
        },
        '&.left-center .gatsby-image-wrapper img': {
            objectPosition: 'left center !important',
        },
        '&.left-bottom .gatsby-image-wrapper img': {
            objectPosition: 'left bottom !important',
        },
        '&.center-top .gatsby-image-wrapper img': {
            objectPosition: 'center top !important',
        },
        '&.center-bottom .gatsby-image-wrapper img': {
            objectPosition: 'center bottom !important',
        },
        '&.right-top .gatsby-image-wrapper img': {
            objectPosition: 'right top !important',
        },
        '&.right-center .gatsby-image-wrapper img': {
            objectPosition: 'right center !important',
        },
        '&.right-bottom .gatsby-image-wrapper img': {
            objectPosition: 'right bottom !important',
        },
    },
    blogBannerTheme: {
        ...theme.blogBannerTheme,
    },
    blogPostMeta: {
        position: 'relative',
        borderBottom: '1px solid ' + theme.palette.secondary.main,
        marginBottom: 36,
        [theme.breakpoints.up('md')]: {
            width: 'calc(100vw - 80px)',
            marginLeft: '50%',
            transform: 'translateX(-50%)',
            '& .MuiGrid-root': {
                flexDirection: 'row-reverse',
                alignItems: 'center',
            }
        },
        '& .social-sharing': {
            [theme.breakpoints.up('md')]: {
                flex: '0 0 33.333%',
                textAlign: 'right',
            },
            '& p': {
                fontSize: 16,
                fontWeight: 'bold',
                fontFamily: theme.headerFont,
                letterSpacing: '0.04em',
                lineHeight: 1.5,
                textTransform: 'uppercase',
                [theme.breakpoints.up('md')]: {
                    marginBottom: 0,
                },
            },
            '& > .link-list': {
                textAlign: 'justify',
                textAlignEnd: 'justify',
                [theme.breakpoints.up('md')]: {
                    display: 'inline-block',
                    verticalAlign: 'middle',
                },
                '& a': {
                    color: theme.palette.primary.main,
                    textAlign: 'center',
                    width: '33.333%',
                    display: 'inline-block',
                    [theme.breakpoints.up('md')]: {
                        display: 'inline-block',
                        width: 56,
                        textAlign: 'right',
                    },
                    '& svg': {
                        width: 26,
                        height: 26,
                    },
                    '& span': {
                        display: 'none',
                    }
                }
            }
        },
        '& .author': {
            '& .icon': {
                width: 44,
                height: 44,
                [theme.breakpoints.up('md')]: {
                    width: 90,
                    height: 90,
                    float: 'left',
                    marginRight: 24,
                    marginBottom: 16,
                }
            },
            '& p': {
                fontWeight: 'bold',
                fontSize: 16,
                lineHeight: 1.25,
                letterSpacing: '0.040em',
                fontFamily: theme.headerFont,
                [theme.breakpoints.up('md')]: {
                    padding: '26px 0',
                },
                '& span': {
                    display: 'block',
                    fontStyle: 'italic',
                    fontWeight: 'normal',
                    letterSpacing: '0.056em',
                    fontSize: 14,
                    fontFamily: theme.bodyFont,
                }
            }
        }
    }
})